// https://vuex.vuejs.org/en/mutations.html

import { cloneDeep } from 'lodash-es';

export default {
  updateLoadingCount(state, payload) {
    const newVal = state.loadingCount + payload;
    state.loadingCount = Math.max(newVal, 0);

    if (payload < 0 && newVal <= 0 && window.location.hash.includes('loading=true')) {
      const path = window.location.pathname.replace('/auth', '/overview') + window.location.search;
      window.open(path, '_self');
    }
  },
  setAccountInfoLoading(state, payload) {
    state.accountInfoLoading = payload;
  },
  // setters
  setCompanyType(state, payload) {
    state.companyType = payload;
  },
  setSelectedFeatures(state, payload) {
    state.selectedFeatures = payload;
  },
  setToolbarActive(state, payload) {
    state.toolbarActive = payload;
  },
  setSDK(state) {
    state.fbSdkLoaded = true;
  },
  setSaverbarActive(state, payload) {
    state.saverbarActive = payload;
  },
  showToast(state, payload) {
    state.toast = true;
    state.toastText = payload.text;
    state.toastColor = payload.color;
    setTimeout(() => {
      state.toast = false;
      state.toastColor = 'toast_default';
    }, state.toastTimeout);
  },
  hideToast(state) {
    state.toast = false;
    state.toastColor = 'toast_default';
  },
  setSaveChanges(state, payload) {
    state.saveChanges = payload;
  },
  setCancelChanges(state, payload) {
    state.cancelChanges = payload;
  },
  setToolbarTitle(state, payload) {
    state.toolbarTitle = payload;
  },
  setSendReviewRequestSms(state, payload) {
    state.smsSettings.sendReviewRequestsSms = payload;
  },
  setSmsPriceLimit(state, payload) {
    state.smsSettings.smsPriceLimit = payload;
  },
  //
  getAccountInfoSuccess(state, payload) {
    state.accountInfo = { ...cloneDeep(state.accountInfo), ...payload };
  },
  deleteFacebookPageId(state) {
    state.accountInfo.facebookPageId = '';
  },
  setFacebookPageId(state, payload) {
    state.accountInfo.facebookPageId = payload;
  },

  getMetafieldsJsonsSuccess(state, payload) {
    state.metafieldsData['widgetBadgeData'] = payload['widgetBadgeData'];
    state.metafieldsData['widgetProductData'] = payload['widgetProductData'];
    state.metafieldsData['widgetGlobalConfig'] = payload['widgetGlobalConfig'];
  },
  getInstallationInfoSuccess(state, payload) {
    state.installationInfo = payload;
  },
  getInstallationInfoFailed() {
    //eslint-disable-next-line no-console
    console.error('Fetching installation info failed');
  },
  getAccountInfoFailed() {
    //eslint-disable-next-line no-console
    console.error('Fetching account info failed');
  },
  setImportsQuotaLeft: (state, payload) => {
    state.accountInfo.reviewImportQuotaLeft = payload;
  },
  setCreditsLeft(state, payload) {
    state.accountInfo.creditsLeft = payload;
  },
  setPlanType(state, payload) {
    state.accountInfo.planType = payload;
  },
  updateAccountInfoBadgeConfig(state, config) {
    const badgeConfig = JSON.parse(state.metafieldsData.widgetGlobalConfig);

    badgeConfig.badge_stars_color = config.stars_color;
    badgeConfig.badge_border_color = config.border_color;
    badgeConfig.badge_background_color = config.background_color;
    badgeConfig.badge_text_color = config.text_color;
    badgeConfig.badge_secondary_text_color = config.secondary_text_color;

    badgeConfig.fonts.badge_average_score = config.average_score_font_size;
    badgeConfig.fonts.badge_primary = config.primary_font_size;
    badgeConfig.fonts.badge_secondary = config.secondary_font_size;

    badgeConfig.badge_shop_reviews_link = config.shop_reviews_link;

    state.metafieldsData.widgetGlobalConfig = JSON.stringify(badgeConfig);
  },
  updateAccountInfoIntegrations(state, payload) {
    state.accountInfo.integrations = payload;
  },
  updateAccountInfoGoogleShoppingIncludeAll(state, payload) {
    state.accountInfo.googleShoppingIncludeAll = payload;
  },
  updateAccountInfoGoogleShoppingActive(state, payload) {
    state.accountInfo.googleShoppingActive = payload;
  },
  updateAccountInfoGoogleShoppingSkuAsGtin(state, payload) {
    state.accountInfo.googleShoppingSkuAsGtin = payload;
  },
  updateGoogleShoppingIntegrationIncludeAll(state, payload) {
    state.accountInfo.googleShoppingIncludeAll = payload;
  },
  updateGoogleShoppingIntegrationSkuAsGtin(state, payload) {
    state.accountInfo.googleShoppingSkuAsGtin = payload;
  },
  updateGoogleShoppingIntegrationActive(state, payload) {
    state.accountInfo.googleShoppingActive = payload;
  },
  updateGoogleShoppingIntegrationExcludeImportedReviews(state, payload) {
    state.accountInfo.excludeImportedReviewsGoogleMerchantFeed = payload;
  },
  updateAccountInfoKlaviyoPreferences(state, payload) {
    state.accountInfo.klaviyoPreferences = payload;
  },
  updateAccountInfoLimespotPreferences(state, payload) {
    state.accountInfo.limespotActive = payload;
  },
  updateAccountInfoWiserPreferences(state, payload) {
    state.accountInfo.wiserActive = payload;
  },
  updateAccountInfoAftershipPreferences(state, payload) {
    state.accountInfo.aftershipPreferences = payload;
  },
  updateAccountInfoGorgiasPreferences(state, payload) {
    state.accountInfo.gorgiasPreferences = payload;
  },
  updateAccountInfoZendeskPreferences(state, payload) {
    state.accountInfo.zendeskPreferences = payload;
  },
  updateAccountInfoOmnisendPreferences(state, payload) {
    state.accountInfo.omnisendPreferences = payload;
  },
  updateAccountInfoAttentivePreferences(state, payload) {
    state.accountInfo.attentivePreferences = payload;
  },
  updateAccountInfoSalesforcePreferences(state, payload) {
    state.accountInfo.salesforcePreferences = payload;
  },
  updateAccountInfoLoyaltyLionPreferences(state, payload) {
    state.accountInfo.loyaltylionPreferences = payload;
  },
  updateAccountInfoSmileIoPreferences(state, payload) {
    state.accountInfo.smileIoPreferences = payload;
  },
  updateAccountInfoRiseAiPreferences(state, payload) {
    state.accountInfo.riseAiPreferences = payload;
  },
  updateAccountInfoGoogleShoppingExcludeImportedReviews(state, payload) {
    state.accountInfo.excludeImportedReviewsGoogleMerchantFeed = payload;
  },
  setGetStartedProperties(state, payload) {
    state.accountInfo[payload] = true;
  },
  setFreePlanOfferFalse(state) {
    state.accountInfo.showFreePlanOffer = false;
    state.accountInfo.shopOnTrialDidntChoosePlan = false;
  },
  updateStepWizardSuccess(state, payload) {
    state.installationInfo.finishedCustomizeWidget = payload.finishedCustomizeWidget;
    state.installationInfo.finishedSetupCoupon = payload.finishedSetupCoupon;
    state.installationInfo.finishedReviewUsOnAppStore = payload.finishedReviewUsOnAppStore;
    state.installationInfo.finishedAutomateReviews = payload.finishedAutomateReviews;
    state.installationInfo.finishedImportReviews = payload.finishedImportReviews;
  },
  updateOnboardingStepSuccess(state, payload) {
    state.accountInfo.onboardingSteps = payload;
  },
  updateOnboardingSteps(state, payload) {
    state.accountInfo.onboardingSteps = payload;
  },
  setKlaviyoStarsColor(state, payload) {
    state.accountInfo.klaviyoPreferences.klaviyoStarsColor = payload;
  },
  getSMSSettings(state, { sendReviewRequestsSms, smsPriceLimit, smsSpentThisMonth }) {
    state.smsSettings.sendReviewRequestsSms = sendReviewRequestsSms;
    state.smsSettings.smsPriceLimit = smsPriceLimit;
    state.smsSettings.smsSpentThisMonth = smsSpentThisMonth;
  },
  getSMSPlansPriceList(state, payload) {
    state.smsPlans = payload;
  },
  setSmsConfirmLink(state, payload) {
    state.smsConfirmLink = payload;
  },
  setImporterProfilesSuccess(state, payload) {
    state.importerProfiles = payload.data;
  },
  decreaseUnansweredCount(state) {
    state.accountInfo.unansweredCount = state.accountInfo.unansweredCount - 1;
  },
  increaseUnpublishedCount(state) {
    state.accountInfo.unpublishedCount = state.accountInfo.unpublishedCount + 1;
  },
  decreaseUnpublishedCount(state) {
    state.accountInfo.unpublishedCount = state.accountInfo.unpublishedCount - 1;
  },
  hideExtensionAnalyticsSuccess(state) {
    state.accountInfo.uiShowExtensionAnalytics = false;
  },
  hideTalkToExpertsSuccess(state) {
    state.accountInfo.uiShowTalkToExprerts = false;
  },
  hideRequestAppStoreReviewWidgetSuccess(state) {
    state.accountInfo.uiShowRequestShopifyReviewWidget = false;
  },
  loadSmartReviewsDataSuccess(state, payload) {
    state.smartReviewsData = payload;
  },
  setSmartReviewsTestingSuccess(state, payload) {
    state.smartReviewsData.pluginTestActive = payload.data.enabled;
  },
  setReferralEmailContent(state, payload) {
    state.accountInfo.referralEmailContent = payload;
  },
  setReferralLeaderboard(state, payload) {
    state.accountInfo.referredLeaders = payload.data;
  },
  setNoReviewsGuideCount(state, payload) {
    state.accountInfo.noReviewsUsersGuideCount = payload.data;
  },
  increaseFeaturedReviewCounter(state) {
    state.accountInfo.featuredReviewCounter = state.accountInfo.featuredReviewCounter + 1;
  },
  updateGetStartedSteps(state, payload) {
    state.accountInfo.getStartedSteps = payload;
  },
  setExtension(state, payload) {
    state.extension.active = payload.active;
    state.extension.version = payload.version;
  },
  updateAccountInfoBazaarvoicePreferences(state, payload) {
    state.accountInfo.bazaarvoicePreferences = payload;
  },
  setFinishSetup(state, payload) {
    if (state.accountInfo?.onboardingSteps && payload != null) {
      state.accountInfo = {
        ...state.accountInfo,
        onboardingSteps: {
          ...state.accountInfo.onboardingSteps,
          finishSetup: payload,
        },
      };
    }
  },
  setShowRatings(state, payload) {
    state.accountInfo.showRatings = payload;
  },
  setHasOpinewBranding(state, payload) {
    state.accountInfo = {
      ...state.accountInfo,
      permissions: payload
        ? state.accountInfo.permissions.includes('no_branding')
          ? state.accountInfo.permissions
          : [...state.accountInfo.permissions, 'no_branding']
        : state.accountInfo.permissions.filter(permission => permission !== 'no_branding'),
    };
  },
};
